<template>
  <div class="flex items-center" :class="!!left || 'justify-center'">
    <p :class="classObject.label">
      <b>{{ status }}</b>
    </p>
  </div>
</template>

<script>
export default {
  props: ["status", "danger", "left"],
  computed: {
    classObject: function () {
      let classes = {
        label: [],
      };
      switch (this.status) {
        case "Abierta":
          classes.label = ["text-yellow-300"];
          break;
        case "Cerrada":
          classes.label = ["text-green-500"];
          break;
      } 
      return classes;
    },
  },
};
</script>